module.exports = __webpack_public_path__ + "static/media/221-Milo-Monolog_ID_2.b41b722e.mp3";